import { AppNextLink } from '@/features/app-next-link';
interface Props {
  text: string;
  isLink?: boolean;
  href?: string;
}
function Title({
  text,
  isLink = false,
  href = ''
}: Props) {
  return isLink ? <AppNextLink href={href} prefetch={false} className='border-r-2 border-brand-secondary bg-white pr-2 text-sm font-bold leading-9 text-text-black lg:leading-6' data-sentry-element="AppNextLink" data-sentry-component="Title" data-sentry-source-file="title.tsx">
            {text}
        </AppNextLink> : <span className='cursor-default border-r-2 border-brand-secondary bg-white pr-2 text-sm font-bold leading-9 text-text-black lg:leading-6' data-sentry-component="Title" data-sentry-source-file="title.tsx">
            {text}
        </span>;
}
export default Title;